export const ConversationList=(messages) => {
    return {
      type:"Conversation_List",
      messages,
      segmentName: "conversationList",
    }
  }